<template>
    <div class="wrapper">
        <Dialog header="Skapa grupp" :visible.sync="displayDialog" >
          <label>Gruppnamn</label>
          <InputText v-model="groupName" />
          <Button class="p-button-success" label="Skapa" @click="onCreateGroup()" />
        </Dialog>
         <Dialog header="Vill du ta bort gruppen?" :visible.sync="displayDeleteDialog" >
          <div style="width:30em">
            <Button class="p-button-danger" label="Ta bort" @click="onRemoveGroup(selectedDeleteGroup)" icon="pi pi-trash" />
          </div>
        </Dialog>
        <Dialog header="Vill du ta bort dokumentet?" :visible.sync="displayDeleteDocDialog" >
          <div v-if="selectedDocToDelete">Dokument: {{selectedDocToDelete.name}}</div><br/>
          <div style="width:30em">
            <Button class="p-button-danger" label="Ta bort" @click="onDeleteDoc(selectedDocToDelete)" icon="pi pi-trash" />
          </div>
        </Dialog>
         <Dialog header="Koppla dokument" :style="{ width: '30vw' }" :visible.sync="displayConnectDialog" >
          <MultiSelect v-model="selectedCustomerPlaces" :options="customerPlaces" style="width:100%" :filter="true" optionLabel="customerId" placeholder="Välj.." dataKey="value">
            <template #value="slotProps">
             <div v-if="slotProps.value.length === 1">
                1 vald (
                  <span v-for="item in slotProps.value" :key="item.id">
                  {{item.label}}
                </span> )
            </div>
            <div v-if="slotProps.value.length > 1">
              {{slotProps.value.length}} valda (
                <span v-for="item in slotProps.value" :key="item.id">
                  {{item.label}},
                </span> )
            </div>
            <div v-if="!slotProps.value || slotProps.value.length === 0">
              <span>Välj leveransställen..</span>
            </div>
          </template>
          <template #option="slotProps">
            <span>{{slotProps.option.label}}</span>
            </template>
          </MultiSelect><br/><br/>
          <Button class="p-button-success" label="Spara" @click="onConnectToObject()" />
        </Dialog>
        <div class="container details">
            <div class="row mb-4">
                <div class="col-md-6">
                  <FileUpload name="uploadFiles[]" url="/api/files" chooseLabel="Välj.." uploadLabel="Ladda upp" @upload="afterUpload" cancelLabel="Avbryt" accept=".pdf" :multiple="true">
                    <template #empty>
                      <p>Släpp filer här</p>
                    </template>
                  </FileUpload>
                </div>
                <div class="col-md-6">
                    <Button label="Skapa grupp" icon="pi pi-plus" @click="onDisplayDialog()" ></Button>
                    <Dropdown v-if="selectedDocs.length > 0" v-model="selectedGroup" :options="groups" optionLabel="name" @change="onAddToGroup()" placeholder="Lägg till i befintlig grupp.." :multiple="false" :filter="true" />
                </div>
            </div>
            <div class="row dashBoardOrdersWrapper">
                <div class="col-md-6">
                    <h2>Dokument</h2>
                      <DataTable :value="documents" sortField="name" @cell-edit-complete="onCellEditComplete" :selection.sync="selectedDocs" :rowHover="true" :rows="50" :paginator="true" :sortOrder="1" editMode="cell" dataKey="id">
                        <Column selectionMode="multiple" :headerStyle="{'width': '3em'}"></Column>
                        <Column field="name" header="Namn" :editable="true" :sortable="true">
                          <template #editor="slotProps">
                            <InputText v-model="slotProps.data[slotProps.column.field]" autofocus />
                          </template>
                        </Column>
                        <Column field="createdAt" header="Skapad"></Column>
                        <Column field="updatedAt" header="Uppdaterad"></Column>
                        <Column field="id" headerStyle="width: 4em">
                          <template #body="slotProps">
                            <Button class="" title="Öppna dokument" @click="openDocument(slotProps.data.id)" icon="pi pi-search" />
                          </template>
                        </Column>
                        <Column headerStyle="width: 5em">
                          <template #body="slotProps" >
                            <Button class="p-button-danger" title="Ta bort" @click="onDisplayDeleteDocDialog(slotProps.data)" icon="pi pi-trash" />
                           </template>
                        </Column>
                      </DataTable>
                </div>
                <div class="col-md-6">
                      <h2>Grupper</h2>
                      <DataTable :value="masterGroups" dataKey="id" sortField="name" @cell-edit-complete="onGroupsCellEditComplete" :rowHover="true" editMode="cell" :rows="50" :paginator="true" :expandedRows.sync="expandedRows">
                        <Column :expander="true" headerStyle="width: 3em" />
                        <Column field="name" :editable="true" header="Namn">
                          <template #editor="slotProps">
                            <InputText v-model="slotProps.data[slotProps.column.field]" autofocus />
                          </template>
                        </Column>
                        <Column header="Antal" headerStyle="width: 5em">
                          <template #body="slotProps">
                            {{slotProps.data.FileToGroups.length}}
                          </template>
                        </Column>
                        <Column headerStyle="width: 5em">
                          <template #body="slotProps">
                            <Button class="p-button-info" title="Koppla" @click="onDisplayConnectDialog(slotProps.data)" icon="pi pi-arrow-right" />
                          </template>
                        </Column>
                         <Column headerStyle="width: 5em">
                            <template #body="slotProps" >
                              <Button class="p-button-danger" title="Ta bort" @click="onDisplayDeleteDialog(slotProps.data)" icon="pi pi-trash" />
                            </template>
                        </Column>
                        <template #expansion="slotProps">
                          <DataTable class="mb-4" :value="slotProps.data.FileToGroups" dataKey="id">
                            <Column>
                              <template #body="slotProps">
                                <a target="_blank" v-bind:href="slotProps.data.url">{{slotProps.data.name}}</a>
                              </template>
                            </Column>
                            <Column headerStyle="width: 4em">
                              <template #body="slotProps" >
                                <Button class="p-button-danger" title="Ta bort" @click="onRemoveDocument(slotProps.data)" icon="pi pi-minus" />
                              </template>
                            </Column>
                          </DataTable>
                          <DataTable :value="getSubGroups(slotProps.data.id)" @cell-edit-complete="onGroupsCellEditComplete" editMode="cell" :expandedRows.sync="expandedRows" dataKey="id">
                              <Column :expander="true" headerStyle="width: 3em" />
                              <Column field="name" :editable="true" header="Namn">
                                <template #editor="slotProps">
                                  <InputText v-model="slotProps.data[slotProps.column.field]" autofocus />
                                </template>
                              </Column>
                              <Column header="Antal" headerStyle="width: 5em">
                                <template #body="slotProps">
                                  {{slotProps.data.FileToGroups.length}}
                                </template>
                              </Column>
                              <Column headerStyle="width: 5em">
                                <template #body="slotProps">
                                  <Button class="p-button-info" title="Koppla" @click="onDisplayConnectDialog(slotProps.data)" icon="pi pi-arrow-right" />
                                </template>
                              </Column>
                              <Column headerStyle="width: 5em">
                                  <template #body="slotProps" >
                                    <Button class="p-button-danger" title="Ta bort" @click="onDisplayDeleteDialog(slotProps.data)" icon="pi pi-trash" />
                                  </template>
                              </Column>
                              <template #expansion="slotProps">
                                <DataTable class="mb-4" :value="slotProps.data.FileToGroups" dataKey="id">
                                  <Column>
                                    <template #body="slotProps">
                                      <a target="_blank" v-bind:href="slotProps.data.url">{{slotProps.data.name}}</a>
                                    </template>
                                  </Column>
                                  <Column headerStyle="width: 4em">
                                    <template #body="slotProps" >
                                      <Button class="p-button-danger" title="Ta bort" @click="onRemoveDocument(slotProps.data)" icon="pi pi-minus" />
                                    </template>
                                  </Column>
                                </DataTable>
                              </template>
                          </DataTable>
                          <div class="mt-4 mb-4">
                            <Button label="Skapa undergrupp" icon="pi pi-plus" @click="onDisplayDialog(slotProps.data)" ></Button>
                          </div>
                        </template>
                      </DataTable>
                    </div>
            </div>
        </div>
        <Toast position="topright" />
    </div>
</template>

<script>

import DataTable from 'primevue/datatable'
import Dialog from 'primevue/dialog'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button'
import moment from 'moment'
import Toast from 'primevue/toast'
import FileUpload from 'primevue/fileupload'
import MultiSelect from 'primevue/multiselect'
export default {
  name: 'DocumentList',
  components: {
    'Toast': Toast,
    DataTable,
    Column,
    InputText,
    Dropdown,
    Button,
    moment,
    Dialog,
    FileUpload,
    MultiSelect
  },
  data () {
    return {
      uploadFiles: [],
      documents: [],
      customerPlaces: [],
      selectedCustomerPlaces: [],
      selectedDocs: [],
      displayDialog: false,
      displayConnectDialog: false,
      displayDeleteDialog: false,
      displayDeleteDocDialog: false,
      groupName: '',
      groups: [],
      expandedRows: [],
      selectedGroup: null,
      selectedDeleteGroup: null,
      selectedDocToDelete: null
    }
  },
  async mounted () {
    this.documents = await this.getDocuments()
    this.groups = await this.getGroups()
    this.customerPlaces = await this.getCustomerPlaces()
  },
  computed: {
    masterGroups () {
      return this.groups.filter(function (item) {
        if (item.parentId === -1) {
          return item
        }
      })
    }
  },
  methods: {
    async getDocuments () {
      let response = await this.$http.get('/api/files')
      return response.data
    },
    async getGroups () {
      let response = await this.$http.get('/api/filegroups')
      return response.data
    },
    async getCustomerPlaces () {
      let response = await this.$http.get('/api/customersplaces')
      return response.data.customersplace.map((el) => ({
        label: el.data.slutkundnamn + ' ' + el.data.name,
        customerId: el.customerPlaceId + ' ' + el.data.slutkundnamn + ' ' + el.data.name,
        value: el.id,
        fileGroups: el.data.fileGroups
      }))
    },
    getSubGroups (parentId) {
      return this.groups.filter(function (item) {
        if (item.parentId === parentId) {
          return item
        }
      })
    },
    async afterUpload () {
      this.documents = await this.getDocuments()
    },
    async afterCreateGroup () {
      this.groups = await this.getGroups()
      this.groupName = ''
    },
    onCellEditComplete (event) {
      this.onSave(event.data)
    },
    onGroupsCellEditComplete (event) {
      this.onGroupEditSave(event.data)
    },
    onDisplayDialog (data) {
      this.displayDialog = true
      this.selectedGroup = data
    },
    onDisplayDeleteDocDialog (data) {
      this.displayDeleteDocDialog = true
      this.selectedDocToDelete = data
    },
    onDisplayConnectDialog (data) {
      this.displayConnectDialog = true
      this.selectedGroup = data
      this.selectedCustomerPlaces = this.customerPlaces.filter(function (item) {
        if (item.fileGroups !== undefined) {
          let result = item.fileGroups.filter(function (fileGroup) {
            if (fileGroup === data.id) {
              return fileGroup
            }
          })
          if (result.length > 0) {
            return item
          }
        }
      })
    },
    onDisplayDeleteDialog (data) {
      this.displayDeleteDialog = true
      this.selectedDeleteGroup = data
    },
    onConnectToObject () {
      for (let item of this.selectedCustomerPlaces) {
        let theGroup = this.selectedGroup
        let result = []
        if (item.fileGroups) {
          result = item.fileGroups.filter(function (fileGroup) {
            if (fileGroup === theGroup.id) {
              return fileGroup
            }
          })
        }
        if (result.length === 0) {
          var url = '/api/customersplaces/updatefilegroups/' + item.value
          this.$http
            .put(url, {
              fileGroup: {
                value: this.selectedGroup.id,
                name: this.selectedGroup.name
              }
            })
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
              this.displayConnectDialog = false
              this.selectedGroup = null
              this.selectedCustomerPlaces = []
            })
            .catch(error => console.log(error))
        }
      }
    },
    async onCreateGroup () {
      let parentId = -1
      if (this.selectedGroup !== undefined) {
        parentId = this.selectedGroup.id
      }
      var url = '/api/filegroups'
      this.$http
        .post(url, {
          fileGroup: {
            name: this.groupName,
            documents: this.selectedDocs,
            parentId: parentId
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
          this.afterCreateGroup()
        })
        .catch(error => console.log(error))
      this.displayDialog = false
    },
    async onGroupEditSave (data) {
      var url = '/api/filegroups/' + data.id
      this.$http
        .put(url, {
          fileGroup: {
            name: data.name
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onAddToGroup () {
      for (let item of this.selectedDocs) {
        this.selectedGroup.FileToGroups.push(item)
      }
      var url = '/api/filetogroups'
      this.$http
        .post(url, {
          data: {
            groupid: this.selectedGroup.id,
            documents: this.selectedDocs
          }
        })
        .then(response => {
          // this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
        })
        .catch(error => console.log(error))
      this.selectedDocs = []
      this.selectedGroup = []
    },
    onRemoveDocument (data) {
      let group = this.groups.find(x => x.id === data.collectionId)
      group.FileToGroups = group.FileToGroups.filter(function (obj) {
        return obj.id !== data.id
      })
      var url = '/api/filetogroup/' + data.id
      this.$http
        .delete(url)
        .then(response => {
          // this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
        })
        .catch(error => console.log(error))
    },
    onDeleteDoc (data) {
      var url = '/api/filetogroup/deletebydocid/' + data.id
      this.$http
        .delete(url)
        .then(response => {
          var urlFile = '/api/files/' + data.id
          this.$http
            .delete(urlFile)
            .then(response => {
              this.displayDeleteDocDialog = false
              this.documents = this.documents.filter(function (obj) {
                return obj.id !== data.id
              })
              this.$toast.add({severity: 'success', summary: 'Dokument borttaget', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    async openDocument (id) {
      let response = await this.$http.get('/api/files/' + id)
      let downloadLink = document.createElement('a')
      downloadLink.href = response.data.url
      downloadLink.download = response.data.name
      downloadLink.target = 'blank'
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
    onRemoveGroup (data) {
      var url = '/api/filegroup/' + data.id
      this.$http
        .delete(url)
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
          this.afterCreateGroup()
        })
        .catch(error => console.log(error))
      for (let item of data.FileToGroups) {
        this.onRemoveDocument(item)
      }
      this.displayDeleteDialog = false
    },
    async onSave (data) {
      var url = '/api/files/' + data.id
      this.$http
        .put(url, {
          file: {
            name: data.name,
            data: data.data
          }
        })
        .then(response => {
          this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Files/DocumentList.vue